'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('community-list', {
      url: '/community/list',
      template: '<community-list></community-list>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/portfolio/community-list/community-list.routes.js